<template>
  <div class="user-search-modal">
    <div class="search-row">
      <AppTextField
        ref="searchField"
        class="search-field"
        label="Sök"
        :model-value="filters.search"
        :autocomplete-off="true"
        placeholder="Namn eller personnummer"
        @update:model-value="setSearch(String($event))"
      >
        <template #icon>
          <SvgIcon :path="mdiMagnify" size="18" />
        </template>
      </AppTextField>
      <p v-if="resultCount" class="text-subtle result-count">{{ resultCount }}</p>
    </div>

    <p v-if="errorMessage" class="error-text mb-4">{{ errorMessage }}</p>

    <UsersTable :model="tableModel" @navigate="emit('close')" />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { mdiMagnify } from '@mdi/js'
import { AppTextField, SvgIcon } from '@staff/ui'

import { useUserSearch } from '@/composables/userSearch'

import UsersTable from './UsersTable.vue'

const emit = defineEmits<{
  (e: 'close'): void
}>()

const searchField = ref<InstanceType<typeof AppTextField> | null>(null)

const { setSearch, filters, searchUserError, tableModel } = useUserSearch()

const errorMessage = computed(() => searchUserError.value?.message ?? '')

const resultCount = computed(() => {
  const { loading, items, totalItems } = tableModel.value
  if (loading || totalItems === 0) return ''

  const hits = totalItems === 1 ? 'träff' : 'träffar'
  return totalItems > items.length ? `Visar ${items.length} av ${totalItems} ${hits}` : `${totalItems} ${hits}`
})

onMounted(() => searchField.value?.focus())
</script>

<style scoped lang="scss">
.search-row {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 16px;
}

.search-field {
  width: min(320px, 100%);
}

.result-count {
  padding-bottom: 8px;
}
</style>
